import * as React from 'react'
function SvgStarFilled(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34.389 15.236l-8.125-1.18-3.634-7.362c-.637-1.286-2.741-1.286-3.377 0l-3.633 7.362-8.126 1.18c-1.538.224-2.161 2.122-1.043 3.213l5.88 5.73-1.387 8.093c-.262 1.532 1.35 2.708 2.731 1.984l7.266-3.82 7.268 3.821c1.37.718 2.995-.44 2.731-1.984l-1.387-8.092 5.88-5.73c1.117-1.093.494-2.99-1.044-3.215z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgStarFilled
